export const normalizeSearchPhrase = (value: string): string => {
  return value.replace(/["',%_]/g, (x: string) => {
    switch (x) {
      case '"':
        return '″';
      case "'":
        return '′';
      case ',':
        return '٫';
      case '%':
        return '％';
      case '_':
        return '＿';
      default:
        return x;
    }
  });
};
